import { render, staticRenderFns } from "./FilterSidebar.vue?vue&type=template&id=2715f406&scoped=true&"
import script from "./FilterSidebar.vue?vue&type=script&lang=js&"
export * from "./FilterSidebar.vue?vue&type=script&lang=js&"
import style0 from "./FilterSidebar.vue?vue&type=style&index=0&id=2715f406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2715f406",
  null
  
)

export default component.exports